import { render, staticRenderFns } from "./TrackingHistoryEvents.vue?vue&type=template&id=13015b7a"
import script from "./TrackingHistoryEvents.vue?vue&type=script&lang=js"
export * from "./TrackingHistoryEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports